import { generatePath } from 'react-router';

import { IClientInstruments } from 'api/clients/types';
import { VIEW_MERCHANT_PAGE } from 'api/merchants/constants';
import LinkCell from 'components/Grids/DataGrid/Cells/LinkCell';
import { appReactMemo } from 'hocs';
import { ROUTES } from 'routes/config/constants';

import { TClientInstrumentRowCellProps } from './types';

const MerchantTerminalNameCell = ({ item, ...rest }: TClientInstrumentRowCellProps) => {
  const { PARAMS, PATH } = ROUTES.MERCHANTS.SUB_PATH.MERCHANT;
  const { id, name = '' } = item.merchantTerminal || {};

  const viewMerchant = generatePath(PATH, { [PARAMS.ID]: String(id) });

  return (
    <LinkCell<IClientInstruments>
      {...rest}
      conditionType={VIEW_MERCHANT_PAGE.CONDITION_TYPE}
      item={item}
      permissions={VIEW_MERCHANT_PAGE.PERMISSIONS}
      text={name}
      to={viewMerchant}
    />
  );
};

export default appReactMemo(MerchantTerminalNameCell);
